import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { useStores } from '../../../../../stores/useStores';
import { FREE_SPINS_BG, FREE_SPINS_BG_SUBTRACT } from '../../../constants';
import { FreeSpinsWidgetTimer } from '../FreeSpinsWidgetTimer/FreeSpinsWidgetTimer';

import styles from './FreeSpinsSmallWidget.module.scss';

interface FreeSpinsSmallWidgetProps {
  eventId: string;
  widgetImageUrl: string;
  count: number;
}

export function FreeSpinsSmallWidget(props: FreeSpinsSmallWidgetProps) {
  const { eventId, widgetImageUrl, count } = props;
  const { userFreeSpinsStore } = useStores();

  const { t } = useTranslation();
  const timerValue = userFreeSpinsStore.getFreeSpinTimerFormatted(eventId, t);
  const noTimer = !timerValue;

  return (
    <div className={styles.container}>
      <div className={classNames(styles.wrapper, noTimer && styles.wrapperNoTimer)}>
        <img alt="" className={styles.bgImageSubtract} src={FREE_SPINS_BG_SUBTRACT} />
        <img alt="" className={styles.bgImage} src={FREE_SPINS_BG} />
        <img alt="" className={styles.img} src={widgetImageUrl} />
        <div className={styles.overlay} />
        <span className={styles.countText}>{count}</span>
        <span className={styles.text}>{t('frb.freeSpins')}</span>
        {noTimer ? null : <FreeSpinsWidgetTimer className={styles.timer} eventId={eventId} />}
      </div>
    </div>
  );
}
